import { useTheme } from '@mui/material'

interface P {
    children?: JSX.Element | JSX.Element[] | string
    style?: React.CSSProperties
    ref?: React.LegacyRef<HTMLDivElement>
    id?: string
}

const Container = ({ children, style, ref, id }: P) => {
    const theme = useTheme()
    return (
        <div
            id={id}
            ref={ref}
            style={{
                ...{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column', gap: theme.spacing(2) },
                ...style
            }}>
            {children}
        </div>
    )
}

interface DetailP {
    flex?: number
    height?: number | string
    spacing?: number
    alignItems?: React.CSSProperties['alignItems']
    justifyContent?: React.CSSProperties['justifyContent']
    ref?: React.LegacyRef<HTMLDivElement>
    className?: string
}

const Row = ({ flex, height, spacing, alignItems, justifyContent, children, style, ref, className }: P & DetailP) => {
    const theme = useTheme()
    return (
        <div
            ref={ref}
            className={className}
            style={{
                ...{ display: 'flex', flexDirection: 'row', alignItems, justifyContent, flex: flex ?? 1, maxHeight: height, height, gap: spacing ? theme.spacing(spacing) : undefined },
                ...style
            }}>
            {children}
        </div>
    )
}

const Column = ({ flex, height, spacing, children, style, ref }: P & DetailP) => {
    const theme = useTheme()
    return (
        <div
            ref={ref}
            style={{
                ...{ display: 'flex', flexDirection: 'column', flex: flex ?? 1, maxHeight: height, height, gap: spacing ? theme.spacing(spacing) : undefined },
                ...style
            }}>
            {children}
        </div>
    )
}

interface TileP {
    display?: 'flex'
    p?: number
}

const Tile = ({ flex, height, display, children, p, style, ref }: P & DetailP & TileP) => {
    const theme = useTheme()
    return (
        <div
            ref={ref}
            style={{
                ...{ flex: flex, maxHeight: height, height, display, padding: p ? theme.spacing(p) : undefined },
                ...style
            }}>
            {children}
        </div>
    )
}

export default { Container, Row, Column, Tile }
